module.exports = __webpack_public_path__ + "img/banner_desktop.d8b404cb.png";